export default __webpack_public_path__ + "static/media/index.js.b8cf0995.map";